import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.4 6.548c-.9-2.444-2.7-4.399-5.1-5.572s-5.1-1.27-7.6-.39C7.3 1.073 6 1.853 5 2.832L2 5.571V1.953c0-.586-.4-.977-1-.977s-1 .39-1 .977v6.16c0 .097.1.097.1.195 0 0 0 .098.1.098.1.097.1.097.2.097l.1.098h6.3c.6 0 1-.39 1-.978 0-.586-.2-.782-.8-.782H3.5l2.8-2.639c.8-.782 1.9-1.466 3-1.857 2-.685 4.2-.587 6.1.293s3.4 2.444 4.1 4.497a7.714 7.714 0 0 1-4.9 9.971c-4.2 1.466-8.7-.684-10.2-4.79-.2-.489-.8-.782-1.3-.587s-.8.782-.6 1.271c1.5 4.008 5.4 6.55 9.5 6.55q1.65 0 3.3-.587c5.2-1.76 8-7.33 6.1-12.415"
    }, null, -1)
  ]))]))
}
export default { render: render }